var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _vm.mode === "onboarding"
                    ? _c(
                        "gg-card-title",
                        {
                          staticClass: "pt-0"
                        },
                        [
                          _vm._v(" Let's get "),
                          _vm.dataLoaded
                            ? _c("span", [_vm._v(_vm._s(_vm.serviceDomain))])
                            : _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  width: "3",
                                  size: "18"
                                }
                              }),
                          _vm._v(" started! ")
                        ],
                        1
                      )
                    : _c(
                        "gg-card-title",
                        {
                          staticClass: "pt-0"
                        },
                        [
                          _vm._v(" Quick Launch Wizard - "),
                          _vm.dataLoaded
                            ? _c("span", [_vm._v(_vm._s(_vm.serviceDomain))])
                            : _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  width: "3",
                                  size: "18"
                                }
                              })
                        ],
                        1
                      ),
                  _vm.mode !== "onboarding"
                    ? _c(
                        "v-stepper",
                        {
                          model: {
                            value: _vm.step,
                            callback: function callback($$v) {
                              _vm.step = $$v
                            },
                            expression: "step"
                          }
                        },
                        [
                          _c(
                            "v-stepper-header",
                            [
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.step > 1,
                                    step: "1"
                                  }
                                },
                                [_vm._v(" Choose Path ")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    complete: _vm.step > 2,
                                    step: "2"
                                  }
                                },
                                [_vm._v(" Setup ")]
                              ),
                              _c("v-divider"),
                              _c(
                                "v-stepper-step",
                                {
                                  attrs: {
                                    step: "3"
                                  }
                                },
                                [_vm._v(" Confirm ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("step-one", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.step === 1,
            expression: "step === 1"
          }
        ]
      }),
      _vm.step === 2 ? _c("step-two") : _vm._e(),
      _vm.step === 3 ? _c("step-three") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }